import {
  IonButton,
  IonButtons,
  IonCard,
  IonCheckbox,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
  IonModal,
  IonProgressBar,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { addCircleOutline, bagOutline, locationOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import UserAvatar from "../../../components/UserAvatar";
import {
  clearCreateFilters,
  setPreselectAll,
  setPreselectUser,
  setRange,
} from "../../../store/massiveDocumentCreate";
import { selectCreateMultipleDocumentFilters } from "../../../store/massiveDocumentCreate/selectors/selectCreateMultipleDocumentFilters";
import { selectEnabledUsers } from "../../../store/massiveDocumentCreate/selectors/selectEnabledUsers";
import { selectFindUserRoleStatus } from "../../../store/massiveDocumentCreate/selectors/selectFindUserRoleStatus";
import { UsersSearchBar } from "./UsersSearchBar";
import { UsersSelectorLocationFilter } from "./UsersSelectorLocationFilter";
import { UsersSelectorOrganizationFilter } from "./UsersSelectorOrganizationFilter";
import UsersExcelUploader from "./UsersExcelUploader";
import { selectFormData } from "../../../store/massiveDocumentCreate/selectors/selectFormData";
import React from "react";

export const UsersSelector = () => {
  const dispatch = useDispatch();

  const users = useSelector(selectEnabledUsers);
  const createFilters = useSelector(selectCreateMultipleDocumentFilters);
  const findStatus = useSelector(selectFindUserRoleStatus);

  const handleRangeChange = async (text: string) => {
    dispatch(setRange(text));
  };

  const handlePreselectAll = async () => {
    dispatch(setPreselectAll(users));
  };

  const creationData = useSelector(selectFormData);
  const tipoAcuerdo = creationData.creationType === "archivo" ? "con archivo" : "con plantilla";

  return (

    <IonCard style={{ height: "75vh", overflow: "auto" }} class="ion-no-margin">
      <IonToolbar>
        <IonTitle size="small" style={{ fontWeight: 500 }}>
          Disponibles ({users.length})
        </IonTitle>
        <IonButtons slot="end">
          {!!users.length && (
            <IonButton fill="solid" size="small" color="primary" onClick={handlePreselectAll}>
              <small>Agregar todos</small>
              <IonIcon icon={addCircleOutline} slot="end" />
            </IonButton>
          )}
        </IonButtons>
        <div style={{ marginTop: 8 }}>
          <UsersExcelUploader />
        </div>
      </IonToolbar>

      <IonItem lines="none" className="ion-padding-start">
        <IonLabel>
          <IonText color="medium">
            <h3 style={{ fontWeight: 400, marginTop: 8 }}>
              Acuerdos masivos <strong>{tipoAcuerdo}</strong>
            </h3>
          </IonText>
        </IonLabel>
      </IonItem>



      <UsersSearchBar />

      <IonCard color="transparent">
        <IonItemDivider>
          Filtros personalizados
          {(createFilters.organization.code || createFilters.location.code) && (
            <IonButtons slot="end">
              <IonButton color="danger" onClick={() => dispatch(clearCreateFilters())}>
                Limpiar filtros
              </IonButton>
            </IonButtons>
          )}
        </IonItemDivider>

        <section style={{ display: "flex", overflow: "auto", padding: 6 }}>
          <UsersSelectorOrganizationFilter />
          <UsersSelectorLocationFilter />
        </section>
        {/* Seleccion de Rango de Location */}
        {(createFilters.organization.code || createFilters.location.code) && (
          <IonItem lines="none" className="ion-margin-bottom">
            <IonLabel position="stacked">Ingresa rango</IonLabel>
            <IonInput
              value={createFilters.range || ""}
              debounce={800}
              placeholder="Ej: 101-110, 121-131"
              onIonChange={({ detail: { value } }) => handleRangeChange(value!)}
            />
          </IonItem>
        )}
      </IonCard>

      {findStatus === "pending" && (
        <p className="ion-text-center">
          <IonSpinner />
        </p>
      )}
      {findStatus === "fulfilled" && (
        <IonList>
          {users.length === 0 && (
            <p className="ion-text-center">
              No hay usuarios disponibles con los filtros seleccionados.
            </p>
          )}
          {users.slice(0, 30).map((userRoleItem) => (
            <IonItem key={userRoleItem.id}>
              <UserAvatar user={userRoleItem.user}></UserAvatar>
              <IonLabel>
                <h2 style={{ fontWeight: 700 }}>
                  <IonText color="primary">{userRoleItem.user.name}</IonText>
                </h2>
                <h4>
                  <IonText color="medium" style={{ fontWeight: 500 }}>
                    <IonIcon icon={bagOutline}></IonIcon>
                    <small className="ion-margin-start">{userRoleItem.role?.name || "--"}</small>
                  </IonText>
                </h4>
                <h4>
                  <IonText color="medium" style={{ fontWeight: 500 }}>
                    <IonIcon icon={locationOutline}></IonIcon>
                    <small className="ion-margin-start">
                      {userRoleItem.location?.name + " (" + userRoleItem.location?.code + ")"}
                    </small>
                  </IonText>
                </h4>
              </IonLabel>
              <IonButton
                fill="clear"
                onClick={() => dispatch(setPreselectUser(userRoleItem))}
                size="large"
              >
                <IonIcon icon={addCircleOutline} />
              </IonButton>
            </IonItem>
          ))}
        </IonList>
      )}
    </IonCard>
  );
};
